import { CurrencyText, TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";
import { TrendingUp, TrendingDown } from "lucide-react";
import { ConfidenceLevel } from "@/components/common/svgs/ConfidenceLevel";
import { useIsDarkTheme } from "@/components/layout/useIsDarkTheme";

export const MarketCard = ({ name, avgRpm, trend, confidence }) => {
    const isDarkTheme = useIsDarkTheme();
    const roundTrend = new Intl.NumberFormat("en-US", { minimumFractionDigits: 0 }).format(Math.round(trend));

    return (
        <div className="flex flex-col border border-cm-p-outline rounded-lg pt-[5px] pb-[7px] px-3 w-full lg:w-[215px] cursor-grab">
            <div className="flex items-center justify-between">
                <div className="flex flex-row gap-[6px] items-center">
                    <div>
                        {roundTrend > 0 ? (
                            <TrendingUp className="w-4 h-4 text-cm-p-accent text-base" />
                        ) : (
                            <TrendingDown className="w-4 h-4 text-cm-p-on-container-red text-base" />
                        )}
                    </div>
                    <div
                        className={cn("font-medium text-sm leading-[22px]", {
                            "text-cm-p-accent": roundTrend > 0,
                            "text-cm-p-on-container-red": roundTrend <= 0,
                        })}
                    >
                        {roundTrend}%
                    </div>
                </div>
                {confidence && (
                    <ConfidenceLevel level={confidence === "high" ? 3 : confidence === "medium" ? 2 : 1} isDarkTheme={isDarkTheme} />
                )}
            </div>

            <div className="text-sm leading-[22px] text-cm-p-text-primary font-medium">{name}</div>
            <div className="text-sm leading-[22px] text-cm-p-text-secondary">
                <CurrencyText num={avgRpm} className="text-sm leading-[22px] text-cm-p-text-secondary" />{" "}
                <TranslatedText text="avg outbound RPM" />
            </div>
        </div>
    );
};
